import './hireNewCreditCardView.scss';

// @vendors
import React, { useEffect, useCallback, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// @helpers
import { i18n } from 'core/i18n';
import { ownerFromAccount } from 'utilities/contactCenter/cardHireHelper';
import { recordLink } from 'utilities/tagging';
import { isAvailableHireCreditCards } from 'utilities/cardsHelper';

// @actions
import * as hireNewCreditCardActions from 'actions/hireNewCreditCard';
import * as hireCreditLimitActions from 'actions/hireCreditLimit';
import * as preContractualMailActions from 'actions/contactCenter/preContractualMailInfo/preContractualMailInfo';
import * as blockedAccountsAction from 'actions/blockedAccounts';
import * as precontractualDocumentMailAction from 'actions/precontractualDocumentsMailer';
import * as termsAndCondsInfoActions from 'actions/termsAndCondsInfo';
import * as hirePaymentMethodActions from 'actions/hirePaymentMethod';
import * as hireCardCreditINEActions from 'actions/commons/hireCardCreditINE';
import * as printedActions from 'actions/contactCenter/printer';
import * as mortgageRequestHolderConfirmation from 'actions/mortgageRequest/mortgageRequestHolderConfirmation';
import * as hireCardImageSelectorActions from 'actions/hireCardImageSelector';

import shippingAddressAction from 'actions/shippingAddress';
import revolvingActions from 'actions/cardRevolvingDocuments';


// @commons
import Wizard from 'components/commons/wizard/wizard';
import WizardStep from 'components/commons/wizardStep/wizardStep';
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';
import { OKCover } from 'commonsComponents/OKCover';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { OKLink } from 'commonsComponents/OKLink';

// @components
import { HireNewCreditCardStep1 } from 'components/hire/newCreditCard/hireNewCreditCardStep1/hireNewCreditCardStep1';
import { HireNewCreditCardInformationCcStep1 } from 'components/hire/newCreditCard/hireNewCreditCardInformationCcStep1/hireNewCreditCardInformationCcStep1';
import { HireNewCreditCardStep2 } from 'components/hire/newCreditCard/hireNewCreditCardStep2/hireNewCreditCardStep2';
import { HireNewCreditCardStep4 } from 'components/hire/newCreditCard/hireNewCreditCardStep4/hireNewCreditCardStep4';
import { HireCardOpenCreditStepINEDIR } from 'components/hire/cardINEDIRDocument/hireCardOpenCreditStepINEDIR';
import HireCardOpenCreditStepINE from 'components/hire/cardINEDocument/hireCardOpenCreditStepINE';
import { HireNewCreditCardSuccess } from 'components/hire/newCreditCard/hireNewCreditCardSuccess/hireNewCreditCardSuccess';
import { HireNewCreditCardError } from 'components/hire/newCreditCard/hireNewCreditCardError/hireNewCreditCardError';
import { HireNewCardSidebar } from 'components/hire/newCreditCard/hireNewCardSidebar/hireNewCardSidebar';
import { CallMeBack } from 'components/callMeBack/callMeBack';
import WebappRender from 'components/conditionalRender/webappRender';
import ContactCenterRender from 'components/conditionalRender/contactCenterRender';
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';
import { LINK_CLICK_ACTION_EVENT } from 'constants/tagging';
import { WEB_INACTIVE_ACCOUNT_ENABLED, ES_COUNTRY, LIMIT_CREDIT_CARD } from 'constants/flagBasedFeatures';

import {
  REDIRECT_URL,
  WIZARD_FIRST_STEP,
  SECOND_STEP,
  THIRD_STEP,
  WIZARD_SECOND_STEP,
  YES_ACCEPTED
} from 'constants/index';
import {
  catalogue,
  analyticsId,
} from 'components/hire/newCreditCard/analytics/hireNewCreditCardViewAnalytics';
import { getCardData, navigateBasedOnCardType, getPlacementIdCard, getServiceCodes, getHireCmsKey } from './hireNewCreditCardViewUtilities';


const { formatText, FormattedText, hasTranslation } = i18n;


const HireNewCreditCardView = (props) => {
  const {
    cardType,
    immFlagBasedFeatures,
    immProfile,
    history,
    getBlockedAccounts,
    immAccounts,
    match: { params: { redirect } },
    resetPrecontractualDocumentMail,
    validateStep,
    getNewCreditCardData,
    reset,
    resetBlockedAccounts,
    resetPrecontractualMail,
    resetTermsAndCondsText,
    hireNewCreditCard,
    immHireCardImageSelector,
    immHireCardNameSelector,
    immHireCreditLimit,
    immHirePaymentMethod,
    immShippingAddressList,
    setVisibleStep,
    setWillCancel,
    toggleCreditLimitModal,
    validate,
    getHiring,
    setTooltipShown,
    handleTypeChange,
    handleValueChange,
    requestAfiInformation,
    setAFIParams,
    setInneParams,
    immPdfRevolvingPersistent,
    newSetHireCreditCardType,
    handleCreditLimitChange,
    handleCreditLimitModalValueChange,
    handleToggleModal,
    immCards,
    immGlobalVariables,
    handleAccountChange,
    immHireContactData,
    setShippingAddress,
    getshippingAddressList,
    setCloseModal,
    documentRead,
    onAcceptAllDocument,
    saveDocumentList,
    checkRadioButtonIneDir,
    cardsConfimationScrollDown,
    checkCheckedDocument,
    printedAndSignedRadioChanged,
    enableButtonOffice,
    checkRadioButton,
    immPrinter,
    hireNewCreditCardPrintDocument,
    myCardsTarjetasHire,
    immHireInformation,
    processEmail,
    getHireCardImages,
    agreeCheckboxCC,
    onHandleChangeCheckBoxCC,
    handleAgreementCheckboxChange
  } = props;

  let immSteps = __CONTACT_CENTER__
    ? (isPrintOfficeMode()
      ? hireNewCreditCard.get('stepsOFI')
      : hireNewCreditCard.get('stepsCC'))
    : hireNewCreditCard.get('steps');

  const visibleStep = hireNewCreditCard.get('visibleStep');

  immSteps = immSteps.map((step, index) => {
    if (index < visibleStep) {
      return step.set('valid', true);
    }
    return step;
  });

  const cardTypes = {
    'via-t': 'via_t',
    'open-credit': 'open_credit',
    'viajera': 'viajera',
    'vanity': 'vanity',
    'diamond': 'diamond',
    'premium': 'premium',
    'virtual': 'virtual'
  };

  const [hireCmsKey, setHireCmsKey] = useState(null);
  const [collectiveLocation, setCollectiveLocation] = useState(null);
  const [contractPdfData, setContractPdfData] = useState(null);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [isCheckboxCheckedStep1, setIsCheckboxCheckedStep1] = useState(false);
  let pageTitle;

  if (__CONTACT_CENTER__) {
    pageTitle = visibleStep <= WIZARD_SECOND_STEP
    ? formatText(`hireNewCreditCard-pageTitle1_${cardTypes[cardType]}`)
    : formatText(`hireNewCreditCard-pageTitleNext_${cardTypes[cardType]}`);
  } else {
    pageTitle = visibleStep === WIZARD_FIRST_STEP
    ? formatText(`hireNewCreditCard-pageTitle1_${cardTypes[cardType]}`)
    : formatText(`hireNewCreditCard-pageTitleNext_${cardTypes[cardType]}`);
  }

  useEffect(() => {
    if (__CONTACT_CENTER__) {
      setIsCheckboxChecked(false);
    }
  }, [visibleStep]);

  useEffect(() => {
    navigateBasedOnCardType(cardType, history, immFlagBasedFeatures, immProfile, hasCardOfType);
  }, [cardType, history, immFlagBasedFeatures, immProfile]);
  const cardImageIds = hireNewCreditCard.get('cardImageIds')
  const EXTRA_IMAGE = cardType === 'diamond' && 'B.506.008.003';

  useEffect(() => {
    resetPrecontractualDocumentMail();
    if (redirect === REDIRECT_URL) {
      validateStep(WIZARD_FIRST_STEP);
    }
    getNewCreditCardData(getCardData(cardType));
  }, []);
  useEffect(() => {
    cardImageIds && getHireCardImages(cardImageIds.toJS(), EXTRA_IMAGE)
  }, [cardImageIds]);
  useEffect(() => {
    return () => {
      reset();
      resetBlockedAccounts();
      resetTermsAndCondsText();
      if (__CONTACT_CENTER__) resetPrecontractualMail();
    };
  }, []);
  useEffect(() => {
    const result = getHireCmsKey(cardType);
    setHireCmsKey(result.hireCmsKey);
    setCollectiveLocation(result.collectiveLocation);
    setContractPdfData(result.contractPdfData);
  }, []);

  const getProcessDetail = useCallback(() => {
    const processDetails = hireNewCreditCard.get('cards').toJS().map(card => `${card.type}.${card.subtype}`);
    return processDetails.length > 0 ? processDetails[0] : '';
  }, [hireNewCreditCard]);
  const processDetail = getProcessDetail();

  const handleCancel = () => {
    history.push('/myprofile/cards');
  };

  const isReady = () => {
    let showPreLeaveModal = true;
    if (hireNewCreditCard.get('visibleStep') === 1) {
      showPreLeaveModal = false;
    }
    return showPreLeaveModal;
  };

  const areRequiredFieldsValid = (newContactData) => {
    const requiredFields = ['number', 'others', 'population', 'postalCode', 'province', 'roadName'];
    return requiredFields.every(field => newContactData[field].isValid);
  }

  const getContextTranslate = (translate) => {
    let context = '';
    switch (cardType) {
      case 'viajera':
        context = `hireCardNeruda-hireCardNeruda_`;
        break;
      case 'vanity':
        context = `hireCardVanity-hireCardVanity_`;
        break;
      case 'hormiguero':
        context = `hireCardNeruda-hireCardNeruda_`;
        break;
      case 'diamond':
        context = `hireCardDiamondPack-`;
        break;
      case 'open-credit':
        context = `hireCardOpenCredit-`;
        break;
      case 'premium':
        context = `hireCardPremiumPack-`;
        break;
      case 'virtual':
        context = `hireCardVirtualCredit-hireCardVirtualCredit_`;
        break;
      case 'via-t':
        context = `hireCardViaT-`;
        break;
    }
    return `${context}${translate}`;
  };

  const buildConfirmationLabel = (labels) => {
    const labelElements = labels.map(item => {
      let element = <span key={item.text}><FormattedText value={item.text} /> </span>;
      let url;

      const href = item.href;
      url = hasTranslation(href) ? formatText(href) : href;

      if (url) {
        element = (
          <OKLink
            key={item.text}
            id={item.id}
            target="_blank"
            to={url}
            modifier="emphasize"
            onClick={() => recordLink(window.utag_last_name, LINK_CLICK_ACTION_EVENT, formatText(item.text))}
          >
            {element}
          </OKLink>
        );
      }

      return element;
    });

    return labelElements;
  }
  const buildSuccessful = () => {

    const selectedAccount = immSteps.getIn([!__CONTACT_CENTER__ ? SECOND_STEP : THIRD_STEP, 'accountId']);
    const immAccount = immAccounts.getIn(['byId', selectedAccount]);
    const immShippingAddress = immShippingAddressList.get('shippingAddress');
    const EXTRA_IMAGE = cardType === 'diamond' && 'B.506.008.003';
    return (
      <div className="col-xs-12 col-md-offset-1 col-md-10">
        <HireNewCreditCardSuccess
          getContextTranslate={getContextTranslate}
          immAccount={immAccount}
          hireCreditCard={hireNewCreditCard}
          immHireCardImageSelector={immHireCardImageSelector}
          immHireCardNameSelector={immHireCardNameSelector}
          immHireCreditLimit={immHireCreditLimit}
          immHirePaymentMethod={immHirePaymentMethod}
          immProfile={immProfile}
          immShippingAddress={immShippingAddress}
          processDetail={processDetail}
          extraImage={EXTRA_IMAGE}
          hireNewCreditCard={hireNewCreditCard}
          cardType={cardType}
        />
      </div>
    );
  }

  const buildWizardHiringSteps = () => {
    const showPreLeaveModal = isReady();
    const printer = immPrinter.get('documentsPrintedAndSigned')
    let finalButtonDisabled;
    if (isPrintOfficeMode()) {
      finalButtonDisabled = printer === YES_ACCEPTED ? false : true
    } else {
      finalButtonDisabled = newFinalButtonDisabledCC ? false : true;
    }
    const wizardActions = {
      cancel: handleCancel,
      finish: myCardsTarjetasHire,
      setVisibleStep,
      setWillCancel,
      validateStep,
    };
    const precontractualConfirmationLabel = [
      {
        text: 'hireCreditCard-textInfoIneDir'
      },
      {
        text: 'hireCreditCard-textLinkInfoIneDir',
        href: 'hireCreditCard-linkInfoIneDir'
      },

    ]

    const immShippingAddress = immShippingAddressList.get('shippingAddress');
    const newShippingAddress = immShippingAddress.toJS();
    const isNewShippingAddress = Object.keys(newShippingAddress).length === 0;
    const filledNewContactData = immHireContactData.toJS();
    const isNewShippingAddressButtonDisabled = areRequiredFieldsValid(filledNewContactData);
    const agreeCheckboxPaymentMethod = hireNewCreditCard.get('agreeCheckboxPaymentMethod')
    const hasShippingAddress = true;
    const productName = getProcessDetail();
    const tealiumData = [
      catalogue[analyticsId.NERURA_CARD_STEP_1_VIEW]({ productName }),
      catalogue[analyticsId.NERURA_CARD_STEP_2_VIEW]({ productName }),
      catalogue[analyticsId.NERURA_CARD_STEP_3_VIEW]({ productName }),
      catalogue[analyticsId.NERURA_CARD_STEP_4_VIEW]({ productName }),
      catalogue[analyticsId.NERURA_CARD_STEP_5_VIEW]({ productName }),
    ];
    const loadingFlag = hireNewCreditCard.get('loadingFlag');
    const method = immHirePaymentMethod.get('type');
    const isShippingAddressButtonDisabled = !!immShippingAddressList && !immShippingAddressList.get('shippingAddressType') && immFlagBasedFeatures.get(ES_COUNTRY);
    const accountIsValid = hireNewCreditCard.getIn(['steps', visibleStep - 1, 'accountIsValid']);
    const initialDocumentsList = hireNewCreditCard.get('initialDocumentsList')
    const acceptedDocument = hireNewCreditCard.get('acceptedDocument')
    const precontractualLabel = buildConfirmationLabel(precontractualConfirmationLabel)
    const allDocumentRead = hireNewCreditCard.get('allDocumentRead')
    const documentINE = hireNewCreditCard.get('documentINE')
    const scrollDown = hireNewCreditCard.get('scrollDown')
    const agreeIneCheckbox = hireNewCreditCard.get('agreeIneCheckbox')
    const checkButtonRadio = hireNewCreditCard.get('checkButtonRadio')
    const printDocument = hireNewCreditCard.get('printDocument')
    const documentsPrintedAndSigned = hireNewCreditCard.get('cardsDocumentsPrintedAndSigned')
    const errorDir = hireNewCreditCard.get('errorDir')
    const newFinalButtonDisabledCC = agreeIneCheckbox || !allDocumentRead
    const getCardTypeString = (cardType) => {
      switch (cardType) {
        case 'diamond':
          return 'diamond';
        case 'open-credit':
          return 'open-credit';
        case 'via-t':
          return 'viat';
        case 'premium':
          return 'premium';
        default:
          return 'open-credit';
      }
    }
    const handleCheckboxChange = (checked) => {
      setIsCheckboxChecked(checked);
    };

    const hireNewCreditCardStep1 = [
      <HireNewCreditCardStep1
        immGlobalVariables={immGlobalVariables}
        hireCreditCard={hireNewCreditCard}
        immHireCreditLimit={immHireCreditLimit}
        immHirePaymentMethod={immHirePaymentMethod}
        toggleCreditLimitModal={toggleCreditLimitModal}
        validate={validate}
        getHiring={getHiring}
        setTooltipShown={setTooltipShown}
        handleTypeChange={handleTypeChange}
        handleValueChange={handleValueChange}
        requestAfiInformation={requestAfiInformation}
        setAFIParams={setAFIParams}
        setInneParams={setInneParams}
        newSetHireCreditCardType={newSetHireCreditCardType}
        immFlagBasedFeatures={immFlagBasedFeatures}
        immPdfRevolvingPersistent={immPdfRevolvingPersistent}
        handleCreditLimitChange={handleCreditLimitChange}
        handleCreditLimitModalValueChange={handleCreditLimitModalValueChange}
        handleToggleModal={handleToggleModal}
        creditType={getCardTypeString(cardType)}
        onCheckboxChange={handleCheckboxChange}
        agreeCheckboxCC={agreeCheckboxCC}
        isCheckboxCheckedStep1={isCheckboxCheckedStep1}
        setIsCheckboxCheckedStep1={setIsCheckboxCheckedStep1}
      />
    ];
    const hireNewCreditCardStep2 = [
      <HireNewCreditCardStep2
        getBlockedAccounts={getBlockedAccounts}
        immAccounts={immAccounts}
        hireNewCreditCard={hireNewCreditCard}
        handleAccountChange={handleAccountChange}
        isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
        getContextTranslate={getContextTranslate}
        immHireCardNameSelector={immHireCardNameSelector}
        immShippingAddressList={immShippingAddressList}
        immHireContactData={immHireContactData}
        setShippingAddress={setShippingAddress}
        getshippingAddressList={getshippingAddressList}
        blockedAccountsSuccess={immAccounts.get('blockedAccountsSuccess')}
        cardType={cardType}
        validateStep={validateStep}
        setCloseModal={setCloseModal}
        visibleStep={visibleStep}
        hasShippingAddress={hasShippingAddress}
        immAddress={immShippingAddress}
        immProfile={immProfile}
      />
    ];
    const hireNewCreditCardStep4 = [
      <HireNewCreditCardStep4
        immHireCardNameSelector={immHireCardNameSelector}
        immHireCreditLimit={immHireCreditLimit}
        immHirePaymentMethod={immHirePaymentMethod}
        immShippingAddressList={immShippingAddressList.get('shippingAddress')}
        placementIdCard={getPlacementIdCard(cardType)}
        hireNewCreditCard={hireNewCreditCard}
        operationParams={getServiceCodes(cardType)}
        immProfile={immProfile}
        immPdfRevolvingPersistent={immPdfRevolvingPersistent}
        immAccounts={immAccounts}
        selectedAccount={immSteps.getIn([!__CONTACT_CENTER__ ? SECOND_STEP : THIRD_STEP, 'accountId'])}
        immFlagBasedFeatures={immFlagBasedFeatures}
        processEmail={processEmail}
        onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
        handleAgreementCheckboxChange={handleAgreementCheckboxChange}
        cardType={cardType}
      />
    ];
    const commonSteps = [
      <WizardStep
        cancelButton={true}
        position="first"
        isLoading={loadingFlag}
        nextButtonCustomText={!__CONTACT_CENTER__ ? formatText('hireNewCreditCard-hireButton') : undefined}
        nextButtonDisabled={__CONTACT_CENTER__ && !isCheckboxChecked}
      >
        <ContactCenterRender>
          <HireNewCreditCardInformationCcStep1
            getContextTranslate={getContextTranslate}
            hireCmsKey={hireCmsKey}
            collectiveLocation={collectiveLocation}
            contractPdfData={contractPdfData}
            immHireInformation={immHireInformation}
            onCheckboxChange={handleCheckboxChange}
          />
        </ContactCenterRender>
        <WebappRender>
          {hireNewCreditCardStep1}
        </WebappRender>
      </WizardStep>,
      <WizardStep
        cancelButton={true}
        omitPreviousButton={__CONTACT_CENTER__ ? true : false}
        nextButtonCustomText={__CONTACT_CENTER__ ? formatText('hireNewCreditCard-hireButton') : undefined}
        nextButtonDisabled={!__CONTACT_CENTER__
          ? isShippingAddressButtonDisabled || !accountIsValid || (isNewShippingAddress && !isNewShippingAddressButtonDisabled)
          : !isCheckboxCheckedStep1 || !agreeCheckboxPaymentMethod && method !== 'PM'}
        onBackClick={false}
        position="middle"
      >
        <ContactCenterRender>
          {hireNewCreditCardStep1}
        </ContactCenterRender>
        <WebappRender>
          {hireNewCreditCardStep2}
        </WebappRender>
      </WizardStep>,
      <WizardStep
        position="middle"
        cancelButton={true}
        onBackClick={false}
        nextButtonDisabled={
          __CONTACT_CENTER__
            ? isShippingAddressButtonDisabled || !accountIsValid || (isNewShippingAddress && !isNewShippingAddressButtonDisabled)
            : (errorDir
              ? (isPrintOfficeMode()
                ? !checkButtonRadio
                : !agreeIneCheckbox)
              : allDocumentRead)
        }
        immFlagBasedFeatures={immFlagBasedFeatures}
      >
        <ContactCenterRender>
          {hireNewCreditCardStep2}
        </ContactCenterRender>
        <WebappRender>
          {__CONTACT_CENTER__ && !isPrintOfficeMode() || errorDir ?
            <HireCardOpenCreditStepINE
              documentINE={documentINE}
              cardsConfimationScrollDown={cardsConfimationScrollDown}
              scrollDown={scrollDown}
              checkCheckedDocument={checkCheckedDocument}
              agreeIneCheckbox={agreeIneCheckbox}
              printedAndSignedRadioChanged={printedAndSignedRadioChanged}
              enableButtonOffice={enableButtonOffice}
              checkRadioButton={checkRadioButton}
              checkButtonRadio={checkButtonRadio}
              hireCardOpenCreditprintDocument={hireNewCreditCardPrintDocument}
              printDocument={printDocument}
              immPrinter={immPrinter}
              documentsPrintedAndSigned={documentsPrintedAndSigned}
            />
            : <HireCardOpenCreditStepINEDIR
              initialDocumentList={initialDocumentsList}
              onSavedocumentAcceptance={documentRead}
              acceptedDocument={acceptedDocument}
              onAcceptAllDocument={onAcceptAllDocument}
              precontractualLabel={precontractualLabel}
              allDocumentRead={allDocumentRead}
              saveDocumentList={saveDocumentList}
              checkRadioButtonIneDir={checkRadioButtonIneDir}
            />
          }
        </WebappRender>

      </WizardStep>,
      <WizardStep
        {
        ...(__CONTACT_CENTER__ && isPrintOfficeMode() ? {
          position: "middle",
          cancelButton: true,
          onBackClick: false,
          nextButtonDisabled: allDocumentRead,
          immFlagBasedFeatures: immFlagBasedFeatures
        } : __CONTACT_CENTER__ ? {
          addLoadingBehaviour: true,
          cancelButton: true,
          immFinalButton: getContextTranslate('hire'),
          isLoading: hireNewCreditCard.get('isFetching'),
          onBackClick: false,
          position: 'last',
          officeSignature: isPrintOfficeMode(),
          finalButtonDisabled: newFinalButtonDisabledCC ? false : true
        } : {
          addLoadingBehaviour: true,
          cancelButton: true,
          immFinalButton: getContextTranslate('hire'),
          isLoading: hireNewCreditCard.get('isFetching'),
          onBackClick: false,
          position: 'last',
          officeSignature: isPrintOfficeMode(),
          finalButtonDisabled: newFinalButtonDisabledCC ? false : true
        })
        }
      >
        {__CONTACT_CENTER__ && isPrintOfficeMode() ? (
          <ContactCenterRender>
            {errorDir ? (
              <HireCardOpenCreditStepINE
                documentINE={documentINE}
                cardsConfimationScrollDown={cardsConfimationScrollDown}
                scrollDown={scrollDown}
                checkCheckedDocument={checkCheckedDocument}
                agreeIneCheckbox={agreeIneCheckbox}
                printedAndSignedRadioChanged={printedAndSignedRadioChanged}
                enableButtonOffice={enableButtonOffice}
                checkRadioButton={checkRadioButton}
                checkButtonRadio={checkButtonRadio}
                hireCardOpenCreditprintDocument={hireNewCreditCardPrintDocument}
                printDocument={printDocument}
                immPrinter={immPrinter}
                documentsPrintedAndSigned={documentsPrintedAndSigned}
              />
            ) : (
              <HireCardOpenCreditStepINEDIR
                initialDocumentList={initialDocumentsList}
                onSavedocumentAcceptance={documentRead}
                acceptedDocument={acceptedDocument}
                onAcceptAllDocument={onAcceptAllDocument}
                precontractualLabel={precontractualLabel}
                allDocumentRead={allDocumentRead}
                saveDocumentList={saveDocumentList}
                checkRadioButtonIneDir={checkRadioButtonIneDir}
              />
            )}
          </ContactCenterRender>
        ) : __CONTACT_CENTER__ ? (
          <ContactCenterRender>
            {hireNewCreditCardStep4}
          </ContactCenterRender>
        ) : (
          <WebappRender>
            {hireNewCreditCardStep4}
          </WebappRender>
        )}
      </WizardStep>,
      __CONTACT_CENTER__ && isPrintOfficeMode() && (
        <WizardStep
          addLoadingBehaviour
          cancelButton={true}
          immFinalButton={getContextTranslate('hire')}
          isLoading={hireNewCreditCard.get('isFetching')}
          onBackClick={false}
          position="last"
          officeSignature={isPrintOfficeMode()}
          finalButtonDisabled={finalButtonDisabled}
        >
          <ContactCenterRender>
            {hireNewCreditCardStep4}
          </ContactCenterRender>
        </WizardStep>
      )
    ];

    return (
      <div>
        <div className="col-xs-12 col-md-8">
          <Wizard
            actions={wizardActions}
            immSteps={immSteps}
            showPreLeaveModal={showPreLeaveModal}
            stepsAmount={immSteps.size}
            wizardClass="hire-card-neruda__wizard"
            tealium={tealiumData[visibleStep - 1]}
            visibleStep={visibleStep}
            isTaggingSecondVersion
          >
            {commonSteps}
          </Wizard>
        </div>
        <div className="col-xs-12 col-md-4">
          <div className="row">
            <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
              <HireNewCardSidebar
                hasShippingAddress={hasShippingAddress}
                immAccounts={immAccounts}
                immAddress={immShippingAddress}
                immHireCardImageSelector={immHireCardImageSelector}
                immHireCardNameSelector={immHireCardNameSelector}
                immHireCreditLimit={immHireCreditLimit}
                immHirePaymentMethod={immHirePaymentMethod}
                immShippingAddressList={immShippingAddressList}
                immProfile={immProfile}
                selectedAccount={immSteps.getIn([__CONTACT_CENTER__ ? THIRD_STEP : SECOND_STEP, 'accountId'])}
                immPdfRevolvingPersistent={immPdfRevolvingPersistent}
                cardType={cardType}
              />
            </div>
            <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
              <CallMeBack
                hasEntrance={false}
                context="contracts"
                modifier="contracts-view"
                pageTitle={formatText('breadcrumb-cards')}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const hasCardOfType = (type) => {
    const typeOfCard = `is${type}Card`;
    const hasCardOfType = immCards.getIn(['credit', 'byOrder']).some(cardId => {
      const immCard = immCards.getIn(['byId', cardId]);
      return immCard.get(typeOfCard) && immCard.get('status') === 'EN VIGOR';
    });
    return hasCardOfType;
  };


  if (__CONTACT_CENTER__) {
    ownerFromAccount(immAccounts);
  }
  const mappingBreadcrumb = [
    {
      text: formatText('breadcrumb-cards'),
      url: '/myprofile/cards',
    },
    {
      text: formatText(`hireNewCreditCard-breadcrumb_${cardTypes[cardType]}`),
    },
  ];
  const hireRestrictionFlag = hireNewCreditCard.getIn([
    'steps',
    WIZARD_FIRST_STEP - 1,
    'hireRestriction',
  ]);

  const isNerudaUser = immProfile.get('isNerudaUser');
  const hasAvailableCreditCards = isAvailableHireCreditCards(immCards);
  const isSecondStep = hireNewCreditCard.get('visibleStep') == WIZARD_SECOND_STEP;
  const creditCardsLimitExceed =
    immFlagBasedFeatures.get(LIMIT_CREDIT_CARD) &&
    !isNerudaUser &&
    !hasAvailableCreditCards &&
    isSecondStep;
  return (
    <div className="hire-card-neruda">
      <div className="container-fluid">
        <div className="row">
          <OKCover size="medium" section="pg" customClass="col-xs-12">
            <OKHeaderSubPage breadcrumbConfig={mappingBreadcrumb} finalTitle={pageTitle} />
          </OKCover>
        </div>
      </div>
      <div className="grid-view__body">
        <div className="container-fluid">
          <div className="row grid-view--content-position-negative">
            {!hireNewCreditCard.get('cardData') ? (
              <LoadingSection />
            ) : hireNewCreditCard.get('error') ? (
              <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HireNewCreditCardError
                  hireNewCreditCard={hireNewCreditCard}
                  hasAvailableAccounts={true}
                  maxAllowedNumberCards={creditCardsLimitExceed}
                  processDetail={processDetail}
                  hireRestrictionFlag={hireRestrictionFlag}
                />
              </div>
            ) : hireNewCreditCard.get('submitSuccessful') ? (
              buildSuccessful()
            ) : (
              buildWizardHiringSteps()
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

module.exports.constructor = HireNewCreditCardView;
module.exports.HireNewCreditCardView = connect(
  state => ({
    immAccounts: state.accounts,
    immCards: state.cards,
    immFlagBasedFeatures: state.flagBasedFeatures,
    immGlobalVariables: state.globalVariables,
    immHireCardImageSelector: state.hireCardImageSelector,
    immHireCardNameSelector: state.hireCardNameSelector,
    immHireInformation: state.hireInformation,
    immHiringProductInformation: state.hiringProductInformation,
    hireNewCreditCard: state.hireNewCreditCard,
    immHireCreditLimit: state.hireCreditLimit,
    immHirePaymentMethod: state.hirePaymentMethod,
    immProfile: state.profile,
    immShippingAddressList: state.shippingAddress,
    immPdfRevolvingPersistent: state.revolvingPersistentData,
    immHireContactData: state.hireContactData,
    immPrinter: state.printer,

  }),
  {
    getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
    resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
    reset: hireNewCreditCardActions.reset,
    getNewCreditCardData: hireNewCreditCardActions.getNewCreditCardData,
    setVisibleStep: hireNewCreditCardActions.setVisibleStep,
    setWillCancel: hireNewCreditCardActions.setWillCancel,
    validate: hireNewCreditCardActions.validate,
    validateStep: hireNewCreditCardActions.validateStep,
    getHiring: hireNewCreditCardActions.getHiring,
    newSetHireCreditCardType: hireNewCreditCardActions.setHireCreditCardLimit,
    handleAccountChange: hireNewCreditCardActions.setAccount,
    setCloseModal: hireNewCreditCardActions.setCloseModal,
    documentRead: hireNewCreditCardActions.documentRead,
    onAcceptAllDocument: hireNewCreditCardActions.onAcceptAllDocument,
    saveDocumentList: hireNewCreditCardActions.saveDocumentList,
    checkRadioButtonIneDir: hireNewCreditCardActions.checkRadioButtonIneDir,
    checkRadioButton: hireNewCreditCardActions.checkRadioButton,
    hireNewCreditCardPrintDocument: hireNewCreditCardActions.printDocument,
    myCardsTarjetasHire: hireNewCreditCardActions.myCardsTarjetasHire,
    resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
    resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
    resetTermsAndCondsText: termsAndCondsInfoActions.reset,
    setTooltipShown: hirePaymentMethodActions.setTooltipShown,
    handleTypeChange: hirePaymentMethodActions.setType,
    handleValueChange: hirePaymentMethodActions.setValue,
    requestAfiInformation: revolvingActions.requestAfiInformation,
    setAFIParams: revolvingActions.setAFIParams,
    setInneParams: revolvingActions.setInneParams,
    handleCreditLimitChange: hireCreditLimitActions.setHireCreditLimit,
    toggleCreditLimitModal: hireCreditLimitActions.toggleModal,
    handleCreditLimitModalValueChange: hireCreditLimitActions.setHireCreditLimitModalValue,
    handleToggleModal: hireCreditLimitActions.toggleModal,
    setShippingAddress: shippingAddressAction.setShippingAddress,
    getshippingAddressList: shippingAddressAction.getShippingAddressList,
    cardsConfimationScrollDown: hireCardCreditINEActions.cardsConfimationScrollDown,
    checkCheckedDocument: hireCardCreditINEActions.checkCheckedDocument,
    printedAndSignedRadioChanged: printedActions.printedAndSignedRadioChanged,
    enableButtonOffice: mortgageRequestHolderConfirmation.enableButtonOffice,
    getHireCardImages: hireCardImageSelectorActions.getHireCardImages,
    agreeCheckboxCC: hireNewCreditCardActions.agreeCheckboxCC,
    processEmail: hireNewCreditCardActions.processEmail,
    onHandleChangeCheckBoxCC: hireNewCreditCardActions.onHandleChangeCheckBoxCC,
    handleAgreementCheckboxChange: hireNewCreditCardActions.setAgreementCheckbox,

  }
)(withRouter(HireNewCreditCardView));
